import { apiPost } from '../config/api';

/**
 * Notify admin that a nurse signed in. Fire-and-forget — login must not block on email.
 */
export async function notifyLogin({ nurseName }) {
  return apiPost('/api/login-alert', { nurseName });
}
